import Pluralize from 'pluralize'

const types = [
  'album',
  'article',
  'discipline',
  'disciplinemanager',
  'facility',
  'group',
  'manager',
  'match',
  'result',
  'round',
  'tag',
  'team',
  'tournament',
  'video',
]

export const Event = {
  CHANGE_FILTER: 'changeFilter',
  CHANGE_GROUP: 'changeGroup',
  ENDED: 'ended',
  SELECTED: 'selected',
}

export const Query = {
  FALSE: JSON.stringify(false),
  TRUE: JSON.stringify(true),
}

export const Resource = (() => {
  const output = {}

  for (let type of types) {
    output[type.toUpperCase()] = Pluralize.plural(type)
  }

  return output
})()

export const Type = (() => {
  const output = {}

  for (let type of types) {
    output[type.toUpperCase()] = type
  }

  return output
})()

export default {
  Event,
  Query,
  Resource,
  Type,
}



// WEBPACK FOOTER //
// ./src/server/helpers/constants.js